import { render, staticRenderFns } from "./EventTicketsDiscounts.vue?vue&type=template&id=aea1a46a&scoped=true"
import script from "./EventTicketsDiscounts.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventTicketsDiscounts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventTicketsDiscounts.vue?vue&type=style&index=0&id=aea1a46a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea1a46a",
  null
  
)

export default component.exports